import React from "react"
import PropTypes from "prop-types"
import {Box, Typography} from "@mui/material"
import FormSectionAccordion from "../../../../../components/FormSectionAccordion"
import ButtonWithIcon from "../../../../../components/Button/Button"
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline"
import theme from "../../../../../theme/theme"
import {ReactComponent as CheckIcon} from "../../../../../assets/icons/check-icon.svg"
import {renderGrid} from "../../../../../components/FieldRenderer"
import {caracteristicasFields, caracteristicasRadios, contrapartesFields} from "./constants"
import {verifyOcr} from "../../../utils/info-section-constants"

const CaracteristicasSection = ({
                                    state,
                                    ocr = false,
                                    ocrState,
                                    setSectionField,
                                    isValid,
                                    showError,
                                    actions,
                                    defaultOpen = false,
                                    syncToken = 0,
                                    autoCompleteController = {},
                                    onRegisterEmpresa,
                                }) => {
    const isValidUrl = (value) => {
        if (!value) return true
        try {
            const url = new URL(value)
            return Boolean(url.host)
        } catch (_e) {
            return false
        }
    }
    const siteFiduciarioInvalid = Boolean(state.siteFiduciario) && !isValidUrl(state.siteFiduciario)

    const fieldErrors = {
        siteFiduciario: siteFiduciarioInvalid
            ? {error: true, helperText: "URL inválida"}
            : undefined,
    }

    const sectionValid = siteFiduciarioInvalid ? false : isValid

    return (
        <Box sx={{mt: {xxxs: -2, md: -3}}}>
            <FormSectionAccordion
                title="Características"
                icon={<CheckIcon style={{color: theme.palette.icon.main, width: 20, height: 20}}/>}
                isValid={sectionValid}
                showError={showError}
                actions={actions}
                defaultOpen={defaultOpen}
                syncToken={syncToken}
            >
                {renderGrid(
                    ocr ? verifyOcr(ocr, ocrState, caracteristicasFields) : caracteristicasFields,
                    state,
                    (key) => (value) => setSectionField("caracteristicas", key, value),
                    fieldErrors,
                    undefined,
                    (key, value) => setSectionField("caracteristicas", key, value),
                    autoCompleteController
                )}

                {renderGrid(
                    ocr ? verifyOcr(ocr, ocrState, caracteristicasRadios) : caracteristicasRadios,
                    state,
                    (key) => (value) => setSectionField("caracteristicas", key, value)
                )}

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        mt: 3,
                        mb: 3,
                    }}
                >
                    <Typography variant="h3" color="common.white">
                        Contrapartes
                    </Typography>
                    <ButtonWithIcon size="md" icon={<AddCircleOutlineIcon/>} onClick={onRegisterEmpresa}>
                        CADASTRAR CONTRAPARTE
                    </ButtonWithIcon>
                </Box>
                {renderGrid(
                    ocr ? verifyOcr(ocr, ocrState, contrapartesFields) : contrapartesFields,
                    state,
                    (key) => (value) => setSectionField("caracteristicas", key, value),
                    undefined,
                    {},
                    (key, value) => setSectionField("caracteristicas", key, value),
                    autoCompleteController
                )}
            </FormSectionAccordion>
        </Box>
    )
}

CaracteristicasSection.propTypes = {
    state: PropTypes.object.isRequired,
    ocr: PropTypes.bool,
    setSectionField: PropTypes.func.isRequired,
    isValid: PropTypes.bool,
    ocrState: PropTypes.object,
    showError: PropTypes.bool,
    actions: PropTypes.node,
    defaultOpen: PropTypes.bool,
    syncToken: PropTypes.number,
    autoCompleteController: PropTypes.object,
    onRegisterEmpresa: PropTypes.func,
}

export default CaracteristicasSection
